export const HEADERS = [
    {
        label: "playerScout.playerName",
        align: "left",
        sortable: true,
        value: "playerName",
        fixed: true,
    },
    {
        label: "playerScout.seasonYear",
        align: "center",
        sortable: true,
        value: "seasonYear",
        fixed: true,
    },
    {
        label: "playerScout.marketValue",
        align: "center",
        sortable: true,
        value: "marketValue",
        fixed: true,
    },
    {
        label: "playerDetail.contractEnd",
        align: "center",
        sortable: true,
        value: "greatestContractDate",
        fixed: true,
    },
    {
        label: "playerScout.age",
        align: "center",
        sortable: true,
        value: "age",
        fixed: true,
    },
    {
        label: "playerScout.height",
        align: "center",
        sortable: true,
        value: "height",
        fixed: true,
    },
    {
        label: "playerScout.side",
        align: "center",
        sortable: true,
        value: "side",
        fixed: true,
    },
    {
        label: "playerDetail.strongFoot",
        align: "center",
        sortable: true,
        value: "tmFoot",
        fixed: true,
    },
    {
        label: "playerScout.gbeScore",
        align: "center",
        sortable: true,
        value: "gbeScore",
        fixed: true,
    },
    {
        label: "playerScout.games",
        align: "center",
        sortable: true,
        value: "gamesPlayed",
        fixed: true,
    },
    {
        label: "playerScout.minutes",
        align: "center",
        sortable: true,
        value: "minutesPlayed",
        fixed: true,
    },
    {
        label: "statsNaming.YellowCards",
        align: "center",
        sortable: true,
        value: "yellowCards",
        fixed: true,
    },
    {
        label: "statsNaming.RedCards",
        align: "center",
        sortable: true,
        value: "redCards",
        fixed: true,
    },
  
];

export default HEADERS;



// WEBPACK FOOTER //
// ./src/views/player/scout_headers.js